import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME, toggleSaveSystemSetting } from './../reducer';
import SystemSettingPopup from './SystemSettingPopup';
import './SaveSystemSetting.scss';

class SaveSystemSettingPopup extends React.Component {
  render() {
    const { isShowPopupSystemSetting, toggleSaveSystemSetting } = this.props;
    return (
      <div className="system-setting">
        {isShowPopupSystemSetting && (
          <div className="popup-save-system-setting">
            <SystemSettingPopup
              isShow={isShowPopupSystemSetting}
              toggleSaveSystemSetting={toggleSaveSystemSetting}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isShowPopupSystemSetting:
      state[REDUCER_NAME].settingSystem.isShowPopupSystemSetting,
  };
};

const mapDispatchToProps = {
  toggleSaveSystemSetting,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SaveSystemSettingPopup);
